import React from 'react';

// Bottom-left branded logo button with a fly-out list of external links
// (home, services, memberships, etc.). The ref is forwarded so the
// app-level click-outside effect can close the tree when the user
// clicks elsewhere.
export default function LinkTreeButton({
  linkTreeConfig,
  isLinkTreeVisible,
  setIsLinkTreeVisible,
  logoUrl,
  playClickSound,
  linkTreeRef,
}) {
  return (
    <div className="fixed bottom-4 left-4 z-40">
      <div
        ref={linkTreeRef}
        className={`absolute bottom-full mb-4 bg-white bg-opacity-90 backdrop-blur-sm rounded-xl shadow-2xl overflow-hidden transition-all duration-300 ease-in-out ${isLinkTreeVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}
        style={{ width: `${linkTreeConfig.size}px` }}
      >
        <div className="p-2 space-y-1">
          {linkTreeConfig.links.map((link, index) => (
            <a
              key={link.id || index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block text-center text-gray-800 font-semibold p-3 rounded-lg hover:bg-gray-200 transition-colors"
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>
      <button
        id="logo-button"
        onClick={() => { playClickSound(); setIsLinkTreeVisible(!isLinkTreeVisible); }}
        className="block focus:outline-none"
      >
        <img
          src={logoUrl}
          alt="Slope Wellness Logo"
          className="w-24 h-auto"
          onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/100x40/FFFFFF/CCCCCC?text=Logo+Error&font=sans'; }}
        />
      </button>
    </div>
  );
}
